module.exports = __webpack_public_path__ + "static/media/promotion_from_30_to_34.122c013b.webp";